import type { DocumentComment } from "../../types";

/** "You" for your own comments, the author's name when the API sent it, else "Collaborator". */
export function commentAuthorLabel(
  comment: Pick<DocumentComment, "created_by_user_id" | "author">,
  currentUserId: string | undefined
): string {
  const userId = comment.created_by_user_id;
  if (userId && currentUserId && userId === currentUserId) return "You";
  const name = [comment.author?.first_name, comment.author?.last_name]
    .map((part) => (part ?? "").trim())
    .filter(Boolean)
    .join(" ");
  return name || "Collaborator";
}
